/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react'
import debounce from 'lodash.debounce'
import { createClient } from 'contentful'
import './App.css'

const client = createClient({
  // This is the space ID. A space is like a projekt folder in Contentful terms
  space: "d5wa5pu6379a",
  // This is the access token for this space. Normally you get both ID and the token in the Contentful web app
  accessToken: "M2LrDS0k_B-c3bpo8ONXv0dSLRH1P1glGRTxWOWhXfw"
});


class App extends React.Component {

  constructor(props) {
    super(props)

    const host = window.location.host || window.location.hostname
    const context = host.match(/([a-z.-]*)\.benedikt-lange.de/)
      ? host.match(/([a-z.-]*)\.benedikt-lange.de/)[1]
      : 'commercials'

    this.state = {
      context,
      items: [],
      isLoading: false,
      hasMore: true,
      query: ''
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.onScoll)

    this.loadProjekts()
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScoll)
  }

  onScoll = debounce((event) => {
    const {
      isLoading,
      hasMore,
    } = this.state;

    // Bails early if:
    // * there's an error
    // * it's already loading
    // * there's nothing left to load
    if (isLoading || !hasMore) return;

    // Checks that the page has scrolled to the bottom
    if (
      window.innerHeight + document.documentElement.scrollTop
      === document.documentElement.offsetHeight
    ) {
      this.loadProjekts();
    }
  }, 100)

  loadProjekts = () => {
    this.setState({ isLoading: true }, () => {
      client
        .getEntries({
          content_type: 'projekt',
          'fields.context': this.state.context,
          order: '-fields.sort',
          // limit: 2, 
          skip: this.state.items.length
        })
        .then(entries => {
          const items = [...this.state.items, ...entries.items]
          this.setState({
            items,
            hasMore: items.length < entries.total,
            isLoading: false,
          })
        })
        .catch(err => {
          this.setState({
            isLoading: false,
            hasMore: false,
          })
          console.log({ err })
        });
    })
  }

  // onSearch = debounce(() => {
  //   if (this.state.query.length <= 1) {
  //     this.setState({ items: [] }, this.loadProjekts)
  //   } else {
  //     client
  //       .getEntries({ 
  //         content_type: 'projekt', 
  //         'fields.context': this.state.context, 
  //         query: this.state.query,
  //         order: '-fields.sort', 
  //         // limit: 2, 
  //         skip: this.state.items.length
  //       })
  //       .then(entries => {
  //         console.log({entries})
  //         const items = [...entries.items]
  //         this.setState({ 
  //           items,
  //           hasMore: false,
  //           isLoading: false,
  //         })
  //       })
  //       .catch(err => {
  //         this.setState({
  //           isLoading: false,
  //           hasMore: false,
  //         })
  //         console.log({err})
  //       });
  //   }
  // }, 250)

  // onChange = (event) => {
  //   this.setState({ query: event.target.value }, this.onSearch);
  // }

  render() {
    let images = []
    if (this.state.items) {
      images = this.state.items.reduce((acc, item) => {
        const images = item.fields.images.map(image => ({
          ...image,
          projekt: item.fields
        }))
        return [
          ...acc,
          ...images
        ]
      }, images)
    }

    return (
      <div className="App">
        <a name="0"></a>
        <header className="Header">
          <Logo />
        </header>
        <main>
          {images.map((item, index) =>
            <Media key={index} {...item} />
          )}
        </main>
        {/* <footer>
          <input
            type="text"
            value={this.state.value}
            onChange={this.onChange}
            style={{ position: 'fixed', border: '1px solid #000', zIndex: 100, bottom: 5, left: 15, right: 15 }} 
          />
        </footer> */}
      </div>
    )
  }
}

export default App

const Logo = (props) => (
  <h1 className="Logo">
    <a href="#0">BenediktLange</a>
  </h1>
)

const Media = (props) => {
  const isVideo = props.fields.file.contentType.substr(0, 6) === 'video/'
  const media = isVideo
    ? <video src={props.fields.file.url} className="Media" controls />
    : <span className="Media">
      <img
        src={props.fields.file.url}
        alt={props.fields.title}
        style={{ maxWidth: '100%' }}
      />
      <span style={{ display: 'block', position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }}></span>
    </span>

  if (props.projekt.link) {
    return isVideo
      ? <span>
        {media}
      </span>
      : <a
        href={props.projekt.link}
        title={props.projekt.title}
        target="_blank"
      >
        {media}
      </a>
  }
  return media
}